module.exports = __webpack_public_path__ + "static/media/BigCaslon-Medium.3e87e8ed.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/BigCaslon-Medium.woff
// module id = 88
// module chunks = 0